import {container, title} from "assets/jss/material-kit-react.jsx";

const signupPageStyle = theme => ({
  container,
  resultsContainer: {
    minHeight: 400,
    padding: 25,
  },
  titleContainer: {
    zIndex: "12",
    color: "#FFFFFF",
    textAlign: "center",
    flexDirection:"column",
    justifyContent:"flex-end",
    alignItems:"center",
    ...container
  },
  bodyContainer: {
    paddingBottom: 50,
    ...container
  },
  resultsContainer: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      // margin: "0 auto",
      // transform: "translate3d(0, -50%, 0)"
    },
  },
  txtCol: {
    // marginTop: "-80px",
    marginTop: 25,
    verticalAlign: "middle",
    "& Button": {
      alignItems: "center",
      paddingBotton: "5px",
      // display: none;
    },
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  searchTitle: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: 30,
    fontSize: 65,
    color: "#FFFFFF",
    textDecoration: "none"
  },
  searchInputContainer: {
    marginTop: 25,
    marginBottom: 25,
    // backgroundColor: "blue",
  },
  searchInput: {
    fontSize: "18px",
    width: 450,
    '&::placeholder': {
      fontSize: "22px",
    },
    [theme.breakpoints.only('sm')]: {
      width: 300,
      '&::placeholder': {
        fontSize: "20px",
      },
    },
    [theme.breakpoints.only('xs')]: {
      width: 250,
      '&::placeholder': {
        fontSize: "18px",
      },
    },
  },
  divider: {
    marginTop: "0px",
    marginBottom: "0px",
    textAlign: "center",
    "& a": {
      color: "#0000ee",
    }
  },
  resetContainer: {
    "& span": {
      "& text": {
        color: "#858585",
        textTransform: "lowercase",
      },
    },
    // "& :hover": {
    //   backgroundColor: "#ebebeb",
    //   color: "white",
    // },
  },
  resetBtn: {
    marginHorizontal: 0,
    padding: 0,
    alignItems: "center",
  },
  resetTxt: {
    fontSize: 14,
    margin: 5,
    textAlign: 'center',
    fontWeight: "500",
    textTransform: "none",
    color: "#bdbdbd",
  },
  searchResTxt: {
    marginTop: "0px",
    marginBottom: "0px",
    textAlign: "center",
    fontSize: 20,
    fontStyle: "italic",
  },
  inputIconsColor: {
    color: "#495057"
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center"
  },
});

export default signupPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/searchPage.jsx